import { render, staticRenderFns } from "./region_dividend_summary_list.vue?vue&type=template&id=5c688ed6"
import script from "./region_dividend_summary_list.vue?vue&type=script&lang=js"
export * from "./region_dividend_summary_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports